<template>
  <div>
  <HomeAltLayout isHome="true" bg_icon='fyiio'>
      <div class="row register-form smallzer">
        <div class="center col s6 m4 offset-m6 offset-s3">
                <a href="http://www.fyi.io">
                  <img class="logo" src="./../../assets/fyiio-logo-with-name.svg" /> 
                </a>
        </div>
      </div>   
      <br> 
      <div class="row register-form smallzer">
        <div class="center col s12 m4 offset-m6">
               <div style="color:white;font-size:36px;font-weight:400;padding: 5px 5px 25px 25px !important" class="valign">Join your organization's workspace</div>
          </div>
    </div>
    
      <form @submit.prevent="login">
       
        <div class="row register-form ">
          <div class="center col s8  offset-s2 m4 offset-m6 " style="background-color:white;border-radius:5px">
            <div class="input-field" style="height:30px">
              <input id="username_inline" type="text" class="fiedler" v-model="username" autocomplete="off" required >
              <label for="username_inline" >Email address</label>
            </div>
          </div>
        </div>
        <div class="row register-form ">
          <div class="center col s8  offset-s2 m4 offset-m6 " style="background-color:white;border-radius:5px">
            <div class="input-field" style="height:30px">
              <input id="inputPassword" type="password" class="fiedler form-control"  v-model="pass" required >
              <label for="inputPassword" >Temporary password</label>
            </div>
          </div>
        </div>
        <div class="row register-form ">
          <div class="center col s8  offset-s2 m4 offset-m6 " style="background-color:white;border-radius:5px">
            <div class="input-field" style="height:30px">
              <input id="inputNewPassword" type="password" class="fiedler form-control"  v-model="newPass" required >
              <label for="inpuNewPassword" >New password</label>
            </div>
          </div>
        </div>
        <div class="row register-form ">
          <div class="col s8  offset-s2 m4 offset-m6 " :class="$mq === 'md'?'left':'center'">
            <button class="btn btn-primary blue" :style="$mq === 'md'?'position:relative; left:-10px':''" style="border-radius:20px;text-transform:none">Accept invitation</button>
          </div>    
        </div>
      </form>

          
        
        <div class="row marketing">
          <p v-if="confirmed" class="message">
            we recommend using a password manager, like SafeInCloud or 1Password, to keep track of all the passwords you have
          </p>

        </div>
      


      




          
    
  </HomeAltLayout>
  </div>
</template>

<script>
import HomeAltLayout from '@/containers/layouts/HomeAltLayout'
export default {
  data () {
    return {
      confirmed: this.$route.query.confirmed || false,
      username: this.$route.query.email || '',
      pass: this.$route.query.temp || '',
      newPass: '',
      error: null
    }
  },
  mounted () {
        M.AutoInit();
        M.updateTextFields();
        $('#bigz').removeClass('blue-bg').addClass('mountain-bg');
  },
  methods: {
    login () {
      this.$cognitoAuth.signinInvitation(this.username, this.pass, this.newPass, (err, result) => {
        if (err) {
          this.error = err
          console.log("error: ", err)
          console.error(err)
        } else {
          this.$router.replace(this.$route.query.redirect || '/tutorials')
        }
      })
    }
  },
  components: {
    HomeAltLayout
  }
}
</script>

<style lang="postcss">
input[type=text]{
   border-bottom: 0px !important;
}
input[type=password]{
   border-bottom: 0px !important;
}

.error {
  color: red;
}
p {
  margin-left: 10px;
}

.mobileLayout {
  background-image: url('./../../assets/pond.png');
  background-size: cover;
}
.mobileLayout.confirmed {
  background-image: url('./../../assets/droids.png');
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/containers/authentication/InvitationAlt.vue